// Sonata lead form: populate UTM / microsite hidden fields on load and push
// the GA "Lead" event after a successful CF7 submission.
//
// The Sonata form is identified by the presence of the `microsite_vc` hidden
// field, so no form ID needs to be passed from PHP.

// GTM stores first-touch attribution in localStorage under these keys.
// Used as fallback when the current URL has no UTM params (e.g. user navigated
// away from the landing page before submitting).
const UTM_LS_KEYS = {
  utm_source: "attr_first_source",
  utm_medium: "attr_first_medium",
  utm_campaign: "attr_first_campaign",
  utm_content: "attr_first_content",
};

function getUtmValue(name) {
  const urlValue = new URLSearchParams(window.location.search).get(name) || "";
  if (urlValue) return urlValue;
  return localStorage.getItem(UTM_LS_KEYS[name]) || "";
}

function setHiddenValue(form, name, value) {
  const input = form.querySelector(`input[name="${name}"]`);
  if (input && value) {
    input.value = value;
  }
}

function isSonataForm(inputs) {
  return inputs.some((input) => input.name === "microsite_vc");
}

function populateSonataForm(form) {
  // Only the Sonata lead form carries the microsite_vc hidden field.
  if (!form.querySelector('input[name="microsite_vc"]')) {
    return;
  }

  const utm_source = getUtmValue("utm_source");
  const utm_medium = getUtmValue("utm_medium");
  const utm_campaign = getUtmValue("utm_campaign");
  const utm_content = getUtmValue("utm_content");
  const microsite_vc = window.location.href;

  setHiddenValue(form, "utm_source", utm_source);
  setHiddenValue(form, "utm_medium", utm_medium);
  setHiddenValue(form, "utm_campaign", utm_campaign);
  setHiddenValue(form, "utm_content", utm_content);
  setHiddenValue(form, "microsite_vc", microsite_vc);
}

export function initSonataForm() {

  // Try to populate forms that are already on the page.
  document.querySelectorAll(".wpcf7 form").forEach(populateSonataForm);

  // Use a MutationObserver to detect forms added dynamically (e.g., in popups).
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          // Check if the added node is a form itself
          if (node.matches(".wpcf7 form")) {
            populateSonataForm(node);
          }
          // Or if it contains a form
          else {
            node
              .querySelectorAll(".wpcf7 form")
              .forEach(populateSonataForm);
          }
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  document.addEventListener("wpcf7mailsent", (event) => {
    const inputs = (event.detail && event.detail.inputs) || [];
    if (!isSonataForm(inputs)) {
      return;
    }

    const valueOf = (name) =>
      (inputs.find((input) => input.name === name) || {}).value || "";

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "Lead",
      TipoIn: 9,
      Edad: 0,
      Ciudad: "0",
      user_email: valueOf("your-email"),
      user_mobile: valueOf("phone"),
    });
  });
}
